import React from 'react';
import './css/GroupIntroduction.css';
import NavBox from '../components/NavBox';
const Values: React.FC = () => {
    const features = [
        {
            title: 'Мэргэжсэн өндөр чадвах',
            description: 'Мэргэжлийн өндөр үр чадвартай, өөрийгөө болон бусдыг байнга хөгжүүлдэг',
            icon: '⭐',
            color: '#444'
        },
        {
            title: 'Багийн сэтгэлгээ',
            description: 'Харилцан итгэлцэл, хүндлэл, эерэг дулаан харьцааг буй болгон хамт олонтойгоо үр дүнтэй хамтран ажилладаг',
            icon: '🔗',
            color: '#a6ce39'
        },
        {
            title: 'Манлайлал',
            description: 'Цаашдын ахиц, хөгжлийн боломжийг олж тодорхойлж, бусдадаа ойлгуулан дэмжлэгийг нь авч, тэднийг урам зоригжуулан, хамтдаа бодит үйл хэрэг болгодог',
            icon: '👑',
            color: '#f23668'
        },
        {
            title: 'Өөриймсөг үзэл',
            description: 'Ажилдаа болон компанидaa өөриймсөг хандаж, сэтгэл гарган ажилладаг',
            icon: '📌',
            color: '#832552'
        },
        {
            title: 'Санал санаачилга',
            description: 'Хөгжүүлэх, сайжруулах, асуудлыг шийдвэрлэх бүтээлч шийдэл, санал санаачлагыг байнга гаргадаг',
            icon: '💡',
            color: '#f98d2f'
        },
        {
            title: 'Үнэнч шударга зарчим',
            description: 'Монгол Улсын хууль журмыг алхам тутамдаа дээдэлдэг, аливаад үнэнч шударга ханддаг, М-Си-Эс группийн ёс зүйн дүрмийг өдөр тутам мөрдлөг болгодог.',
            icon: '🧭',
            color: '#27a7e7'
        }
    ];

    return (
        <div className="page-container">
            <NavBox />
            <div className="content-area1">
                <h1 className="content-title1">Эрхэм зорилго</h1>
                <div className="image-section1">
                    <img
                        src="https://mcs.mn/wp-content/uploads/2019/12/world.jpg"
                        alt="Workspace"
                        className="content-image1"
                    />
                </div>

                <div className="text-section">
                    <p className="content-text">
                        Эрчим хүчний зөвлөгөө өгөх чиглэлээр 1993 онд үүсгэн байгуулагдсан М-Си-Эс компани шилжилтийн он жилүүдэд олон салбарт бизнесийн үйл ажиллагаа эрхлэн, улсын нийгэм, эдийн засгийн хөгжилд хувь нэмрээ оруулсаар ирсэн бөгөөд өдгөө татвар шимтгэл, хөрөнгө оруулалт, ажлын байр зэрэг үзүүлэлтээр тэргүүлэгч үндэсний томоохон Групп болоод байна. Аливаа улс орны хөгжлийг шинэ шатанд хүргэдэг дэд бүтэц, эрчим хүч, инженеринг, мэдээлэл, харилцаа холбоо, барилга, үл хөдлөх хөрөнгийн салбар, эдийн засгийг үлэмж тэтгэдэг уул уурхай, өргөн хэрэглээний бараа бүтээгдэхүүнийн салбар, нийгмийн сайн сайхан, хүний хөгжлийг дэмждэг эрүүл мэнд, боловсрол зэрэг чухал салбарт ажилласан он жилүүддээ бид тогтсон байгууллагын соёлтой, төлөвшсөн боловсон хүчинтэй, түүчээлэх өрсөлдөх чадвартай Групп болон тэлжээ.
                    </p>
                    <p className="content-text">
                        Өдөрт 3.6 тэрбум, сард 108 гаруй тэрбум төгрөгийн татвар, шимтгэлийг улсын төсөвт төвлөрүүлж, өөрийн 14,000 ажилтандаа сард 58 тэрбум төгрөгийн цалин олгохоос гадна дотоодын 8600 гаруй бизнес эрхлэгчээс сард 258 тэрбум төгрөгийн бараа, ажил үйлчилгээ худалдан авч, шууд бусаар мөн 20,000 хүнийг тогтмол ажлын байртай болгож, сард доод тал нь 20 орчим тэрбум төгрөгийн цалин тавих боломжийг олгон улс орны нийгэм, эдийн засгийн хөгжилд бодитой, том хувь нэмрийг оруулж байна.
                    </p>
                    <p className="content-text">
                        Бизнесийн цар хүрээ тэлж, компаниуд маань өсч томрохын хэрээр нийгэм, улс орныхоо өмнө хүлээх бидний үүрэг, хариуцлага улам бүр өндөрсөж, дэлхийн стандарт, дэвшилтэт техник, технологийг эх орондоо нэвтрүүлж, нийгмийн өмнө хүлээсэн хариуцлагаа бүрэн дүүрэн хэрэгжүүлэхийг эрхэм зорилгоо болгон ажиллаж байна.
                    </p>
                </div>
                <div className="feature-grid">
                    {features.map((feature, index) => (
                        <div
                            className="feature-card"
                            key={index}
                            style={{ '--feature-color': feature.color } as React.CSSProperties}
                        >
                            <div
                                className="feature-icon"
                                style={{ backgroundColor: feature.color }}
                            >
                                <span>{feature.icon}</span>
                            </div>
                            <div className="feature-content">
                                <h3>{feature.title}</h3>
                                <p>{feature.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};


export default Values;



